import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setHeaderTitle } from '../../redux/App/App.slice';
import styled from 'styled-components';
import { StyledCard } from '../../components/Card.component';
import EmailTemplateBlock from '../../components/Profile/EmailTemplateBlock.component';
import { useAppDispatch } from '../../hooks/useAppDispatcher.hook';
import { EventStatusCode } from '../../redux/Event/Status/EventStatus.type';
import { checkUserRequiredRole } from '../../utils/getUserRolesByToken';
import useAuthHook from '../../hooks/useAuth.hook';
import { UserRole } from '../../types/userRole.types';

const StyledHeader = styled.div`
  font-size: 24px;
  font-weight: 600;
`;

const StyledDivider = styled.hr`
  margin: 20px 0 20px;
  color: ${({ theme }) => theme.colors.BORDER};
`;

const StyledProfilePage = styled.div`
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 20px;
`;

const StyledProfileContainer = styled(StyledCard)`
  padding: 20px;
`;

const StyledContainerDescription = styled.p`
  margin-bottom: 20px;
`;

const ProfilePage = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { user } = useAuthHook();

  useEffect(() => {
    dispatch(setHeaderTitle(t('profile')));
  }, [t, dispatch]);

  return (
    <StyledProfilePage>
      {checkUserRequiredRole(user.roles, [
        UserRole.HR,
        UserRole.DEV_HR,
        UserRole.SUPER_HR,
        UserRole.DEV_SUPER_HR,
        UserRole.ADMIN,
        UserRole.DEV_ADMIN,
      ]) && (
        <StyledProfileContainer>
          <StyledHeader>{t('autoReplies')}</StyledHeader>

          <StyledContainerDescription>
            {t('templatesForAutomaticReplies')}
          </StyledContainerDescription>

          <StyledDivider />

          <EmailTemplateBlock
            statusCode={EventStatusCode.COMMUNICATION_REJECT}
          />

          <StyledDivider />

          <EmailTemplateBlock
            statusCode={EventStatusCode.PRE_INTERVIEW_REJECT}
          />

          <StyledDivider />

          <EmailTemplateBlock statusCode={EventStatusCode.INTERVIEW_REJECT} />
        </StyledProfileContainer>
      )}
    </StyledProfilePage>
  );
};

export default ProfilePage;
